import React, { useEffect, useRef } from 'react';
import { useZitoneoServices } from '../../contexts/ZitoneoContentContext';
import { ZitoneoViewMode } from '../../types/zitoneoServicesTypes';
import EditorView from './EditorView';
import PreviewView from './PreviewView';
import ZitoneoFooter from '../../main/ZitoneoFooter';
import { useZitoneoUI } from '../../contexts/ZitoneoUIContext';
import useLanguage from '../../../../customHooks/useLanguage';
import SettingsView from './SettingsView';

const ZitoneoServices = () => {
    const appLanguage = useLanguage();
    const { languages } = useZitoneoServices();
    const { viewMode, handleResetUI } = useZitoneoUI();

    const languagesRef = useRef(languages);
    const appLanguageRef = useRef(appLanguage);

    useEffect(() => {
        languagesRef.current = languages;
    }, [languages]);

    useEffect(() => {
        appLanguageRef.current = appLanguage;
    }, [appLanguage]);

    useEffect(() => {
        return () => {
            handleResetUI(languagesRef.current, appLanguageRef.current);
        };
    }, []);

    return (
        <>
            {viewMode === ZitoneoViewMode.EDITOR ? (
                <EditorView />
            ) : viewMode === ZitoneoViewMode.PREVIEW ? (
                <PreviewView />
            ) : (
                <SettingsView />
            )}
            <ZitoneoFooter />
        </>
    );
};

export default ZitoneoServices;
